<div class="wrapper cv-dialog-form">
	<div></div>
	<div class="card-detail backgrd">
		<label class="data-field">EndPoint :</label>
		<label *ngIf="source !== 'EVO'" class="data-value">/{{ source }}/{{ orderId }}/{{ methodUrl }}/</label>
		<label *ngIf="source === 'EVO'" class="data-value">/{{ source }}/{{ orderId }}/{{ serviceId }}/{{ methodUrl }}/</label>
	</div>
	<div class="card-detail">
		<label class="data-field">OrderId :</label>
		<label class="data-value">{{ orderId }}</label>
	</div>
	<ace-editor
		#markupEditor
		[(text)]="responseInformation"
		[mode]="'json'"
		[ngStyle]="{
			height: '200px',
			width: '100%'
		}"
	>
	</ace-editor>
</div>
